module.exports = __webpack_public_path__ + "img/Discover.6d19ec5b.svg";